const generalData = (state, data) => {
  ////////////////Dependencia//////////////////
  try {
    data.dependencia =
      state.dependenciaPolicial != undefined ? state.dependenciaPolicial : state.dependencia;
    data.departamento =
      state.dependenciaDepartamento != undefined
        ? state.dependenciaDepartamento
        : state.departamento;
    data.dependenciaDomicilio =
      state.dependenciaDomicilio != undefined ? state.dependenciaDomicilio : "";
  } catch (e) {
    console.log("error", e);
    data.dependencia = state.dependencia;
    data.departamento = state.departamento;
    data.dependenciaDomicilio =
      state.dependenciaDomicilio != undefined ? state.dependenciaDomicilio : "";
  }

  ////////////////Guardamos formType en caso de Refresh////////////
  if (!data.formType) {
    //si formType llega vacio, recuperamos el ultimo usado en sessionStorage
    data.formType = sessionStorage.formType;
  } else {
    sessionStorage.setItem("formType", data.formType); //guardamos este dato por si la pag se actualiza
  }
};
export default {
  generalData,
};
